<mat-card class="comunicare-widget" cdkDrag [cdkDragDisabled]="!isDraggable">
  <mat-card-header class="widget-header">
    <mat-card-title class="custom-widget-title">
      {{ "widget.lastActivityPatient" | translate }}
      <a mat-icon-button aria-label="icon button with a ? icon" (click)="openInactifPatients()">
        <mat-icon>help_outline</mat-icon>
      </a>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="widget-content">
    <app-date-interval-selector
      class="date-filter"
      [ngClass]="{ hide: loading }"
      [initialFromDate]="fromDate"
      [initialToDate]="toDate"
      (changeDate)="onDateIntervalChange($event)"
    ></app-date-interval-selector>
    <table
      mat-table
      matSort
      matSortActive="date"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource"
      [ngClass]="{ hide: totalCount === 0 || loading }"
    >
      <!-- Patient Column -->
      <ng-container matColumnDef="patient">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "table.patient" | translate }}
        </th>
        <td mat-cell class="noPadding custom-widget-font" *matCellDef="let element">
          <button
            mat-button
            class="normalWeight custom-widget-font"
            [routerLink]="['/patient', { id: encodeToB64(getCaremateIdentifier(element)) }]"
            [state]="{
              caremateIdentifier: getCaremateIdentifier(element),
              widget: widgetName.PATIENT_LAST_ACTIVITY
            }"
            matTooltip="{{ element | getPatientFullName }}"
            matTooltipClass="truncatedNamesTooltip"
          >
            <mat-icon>face</mat-icon>
            {{ element | getPatientFullName | truncate : 30 }}
          </button>
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "table.date" | translate }}
        </th>
        <td mat-cell class="custom-widget-font" *matCellDef="let element">
          {{ element.lastActivity | safeDate : "short" }}
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="text-align: center">
          {{ "table.action" | translate }}
        </th>
        <td mat-cell class="custom-widget-font" *matCellDef="let element">
          <button
            *ngIf="!element.processedNoDataTransmissionRuleAlert"
            mat-icon-button
            matTooltip="{{ 'btn.setSeen' | translate }}"
            (click)="onDetails(element, false)"
            aria-label="icon button with a pencil icon"
          >
            <mat-icon class="custom-icon-small warn">add_task</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="{{ 'btn.details' | translate }}"
            (click)="onDetails(element, true)"
            aria-label="icon button with a loupe icon"
          >
            <mat-icon class="custom-icon-small">search</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      #paginator
      [pageIndex]="0"
      [pageSize]="5"
      [length]="totalCount"
      [hidePageSize]="true"
      [ngClass]="{ hide: totalCount === 0 || loading }"
    ></mat-paginator>
    <p class="text-center custom-widget-font" *ngIf="totalCount === 0 && !loading">
      {{ "widget.noData" | translate }}
    </p>
    <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
  </mat-card-content>
</mat-card>
